<template>
    <div>
        <CCard v-if="useFilter" class="p-1">
            <CCardBody>
                <CRow>
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="showFilters"
                        class="ml-3" />
                    <span class="ml-2">Фильтры</span>
                </CRow>
                <CRow v-if="showFilters" class="mt-3 mb-0">
                    <!-- <CCol cols="12" md="3" class="mb-0">
                        <CSelect 
                            :value.sync="filter.type"
                            :horizontal="true"
                            :options="typeList"
                            label="Тип"
                            placeholder="Выберите тип">
                        </CSelect>
                    </CCol> -->
                    <CCol
                        cols="12"
                        md="4"
                        class="mb-0">
                        <CSelect 
                            :value.sync="filter.os"
                            :horizontal="true"
                            :options="osList"
                            label="Платформа"
                            placeholder="Выберите платформу" />
                    </CCol>
                    <CCol
                        cols="12"
                        md="4"
                        class="mt-1 mb-1 flex">
                        <CSwitch
                            color="dark"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="filter.returned"
                            class="ml-2" />
                        <span class="ml-2">Только повторы</span>
                    </CCol>
                    <CCol
                        cols="12"
                        md="4"
                        class="mt-1 mb-1 flex">
                        <CSwitch
                            color="dark"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="filter.auth"
                            class="ml-2" />
                        <span class="ml-2">Только аторизовавшиеся</span>
                    </CCol>
                    <CCol
                        cols="12"
                        md="4"
                        class="mt-0 mb-1">
                        <DatePicker
                            v-model="filter.created_at.from"
                            :language="datepicker.lang"
                            :format="datepicker.format"
                            input-class="form-control custom-datepicker"
                            placeholder="Дата с..." />
                    </CCol>
                    <CCol
                        cols="12"
                        md="4"
                        class="mt-0 mb-1">
                        <DatePicker
                            v-model="filter.created_at.to"
                            :language="datepicker.lang"
                            :format="datepicker.format"
                            input-class="form-control custom-datepicker"
                            placeholder="Дата по..." />
                    </CCol>
                </CRow>
                <CRow v-if="showFilters">
                    <CCol
                        cols="12"
                        md="6"
                        class="mt-1">
                        <CButton
                            v-if="useFilter"
                            class="ml-0"
                            color="primary"
                            @click="$emit('set-filter', filter)">Применить</CButton>
                        <CButton
                            v-if="useFilter"
                            class="ml-2"
                            color="secondary"
                            @click="resetFilters">Сбросить</CButton>
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>
        
        <CRow>
            <CCol class="font-weight-bold text-right mb-2">
                Всего найдено: {{ itemsCount }}
            </CCol>
        </CRow>

        <CDataTable
            class="customers"
            hover
            :items="list"
            :fields="fields">
            <template #app_version="data">
                <td>
                    {{ data.item.app_version ? data.item.app_version : '' }}
                </td>
            </template>
            <template #os="data">
                <td>
                    {{ data.item.os ? data.item.os + ' ' + data.item.os_version : '' }}
                </td>
            </template>
            <template #customer_id="data">
                <td>
                    <CLink v-if="data.item.customer_id" :to="`/customers/${data.item.customer_id}`">{{
                        data.item.customer.phone
                    }}</CLink>
                </td>
            </template>
            <template #created_at="data">
                <td>
                    {{ data.item.created_at ? formatDate(data.item.created_at) : '' }}
                </td>
            </template>
            <template #auth_at="data">
                <td>
                    {{ data.item.auth_at ? formatDate(data.item.auth_at) : '' }}
                </td>
            </template>
            <template #type="data">
                <td>
                    {{ data.item.type ? CUSTOMER_LOG_TYPE_TITLE[data.item.type] : '' }}
                </td>
            </template>
            <template #returned="data">
                <td>
                    {{ (CUSTOMER_LOG_TYPE.FIRST_OPEN === data.item.type) ? (data.item.returned ? 'Да' : 'Нет') : '' }}
                </td>
            </template>
        </CDataTable>

        <CModal
            title="Настройки отображения"
            :show.sync="settingsModal"
            :footer="true"
            color="info">
            <template>
                <div slot="header">Настройки отображения</div>
                <div slot="body-wrapper" class="modal-body">
                    <CRow v-for="field in fieldsAll" :key="field.key">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">
                            {{ field.label }}
                        </CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="fieldsSettings[field.key]" />
                        </CCol>
                    </CRow>
                </div>
                <div slot="footer">
                    <CButton color="primary" @click="closeSettingsModal">Сохранить</CButton>
                </div>
            </template>
        </CModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    require('moment-countdown');

    const { formatDate } = require('../utils/views');
    const { CUSTOMER_LOG_TYPE, CUSTOMER_LOG_TYPE_TITLE } = require('../utils/customerLog');

    export default {
        components: {
            Multiselect,
            DatePicker,
        },

        props: {
            list: {
                type: Array,
                default: () => [],
            },
            orderType: {
                type: String,
                default: 'all',
            },
            useFilter: {
                type: Boolean,
                default: false,
            },
            useSorter: {
                type: Boolean,
                default: false,
            },
            itemsCount: {
                type: Number,
                default: 0,
            }
        },

        data() {
            return {
                isAuthorized: false,
                CUSTOMER_LOG_TYPE,
                CUSTOMER_LOG_TYPE_TITLE,
                typeList: [
                    { value: 'any', label: 'Все' },
                    { value: '1', label: 'Установка' },
                    { value: '2', label: 'Авторизация' }
                ],
                osList: [
                    { value: 'any', label: 'Все' },
                    { value: 'ios', label: 'iOS' },
                    { value: 'android', label: 'Android' }
                ],
                fieldsAll: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    // { key: "type", label: "Тип" },
                    { key: 'created_at', label: 'Время' },
                    { key: 'device_id', label: 'ID устройства' },
                    { key: 'returned', label: 'Повтор' },
                    { key: 'os', label: 'Платформа' },
                    { key: 'app_version', label: 'Версия приложения' },
                    { key: 'customer_id', label: 'Пользователь' },
                    { key: 'auth_at', label: 'Время авторизации' },
                ],
                // Fields
                fieldsSettings: {},
                settingsModal: false,
                // Filters
                showFilters: false,
                filter: {
                    type: 'any',
                    os: 'any',
                    created_at: {
                        from: '',
                        to: '',
                    },
                },
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
            };
        },

        computed: {
            fields() {
                const result = [];
                for (const item of this.fieldsAll) {
                    if (item.key === 'type') {
                        if (this.orderType === 'all') {
                            if (this.fieldsSettings[item.key]) {
                                result.push(item);
                            }
                        }
                    } else {
                        if (this.fieldsSettings[item.key]) {
                            result.push(item);
                        }
                    }
                }
                return result;
            },
        },

        async created() {
            this.fieldsSettings = this.getFildsSettings();
        },

        methods: {
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            formatDate(ISOString) {
                return formatDate(ISOString);
            },
            // Fields settings
            getFildsSettings() {
                var fieldsSettings = JSON.parse(
                    localStorage.getItem('customers-table-settings')
                );
                if (!fieldsSettings) {
                    fieldsSettings = this.getDefaultFieldsSettings();
                }
                return fieldsSettings;
            },
            getDefaultFieldsSettings() {
                const result = {};
                for (const item of this.fieldsAll) {
                    result[item.key] = true;
                }
                return result;
            },
            setFieldsSettings(fieldsSettings) {
                localStorage.setItem(
                    'customers-table-settings',
                    JSON.stringify(fieldsSettings)
                );
            },
            openSettingsModal() {
                this.settingsModal = true;
            },
            closeSettingsModal() {
                this.setFieldsSettings(this.fieldsSettings);
                this.settingsModal = false;
                this.$forceUpdate();
            },
            resetFilters() {
                this.filter = {
                    type: 'any',
                    os: 'any',
                    created_at: {
                        from: '',
                        to: '',
                    },
                };
                this.showFilters = false;

                this.$emit('set-filter', null);
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.status-cell span {
    display: block;
}
.custom-datepicker.form-control:disabled, .custom-datepicker.form-control[readonly] {
    background-color: #ffffff;
}
</style>
